import { render, staticRenderFns } from "./payments-balances-inquiry.vue?vue&type=template&id=080f4dea&"
import script from "./payments-balances-inquiry.vue?vue&type=script&lang=js&"
export * from "./payments-balances-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports